export interface ArticleDetailData {
  id: string;
  title: string;
  titleLine1: string;
  titleLine2: string;
  titleLine3: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  tag: string;
  date: string;
  views: string;
  source: string;
  heroImageUrl: string;
  contentHtml: string;
  relatedArticles: {
    id: string;
    title: string;
    excerpt: string;
    imageUrl: string;
    date: string;
  }[];
}

const a1: ArticleDetailData = {
  id: "article-1",
  title: "某千万粉网红深夜直播翻车，背后金主身份遭实锤曝光",
  titleLine1: "千万粉网红",
  titleLine2: "深夜直播翻车",
  titleLine3: "金主实锤曝光",
  excerpt: "据知情人士透露，该网红与多位娱乐圈资本大佬关系密切，直播翻车后大量黑料被网友扒出，涉及合同欺诈与虚假人设。",
  category: "网红塌房",
  categorySlug: "influencer-scandal",
  tag: "独家爆料",
  date: "2026-07-06",
  views: "128.6万",
  source: "51吃瓜黑料编辑部",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20cinematic%20scene%20of%20a%20streaming%20studio%20with%20dramatic%20red%20and%20amber%20lighting%2C%20abstract%20silhouette%20of%20a%20person%20at%20a%20desk%20with%20multiple%20screens%2C%20tense%20atmosphere%2C%20warm%20dark%20tones%2C%20editorial%20photography%20style%20with%20soft%20shadows%20and%20cinematic%20composition&width=1600&height=900&seq=article-hero-01&orientation=landscape",
  contentHtml: `
    <p>近日，一位拥有千万粉丝的知名网红在深夜直播中突然情绪失控，引发了一场席卷全网的吃瓜风暴。据现场观众描述，该主播在直播过程中突然接到一个神秘电话，随后脸色大变，匆忙下播。这一异常举动立即引起了粉丝和吃瓜群众的广泛关注。</p>
    <h2>直播翻车始末</h2>
    <p>据当晚在线观看直播的网友回忆，该网红在直播进行到约两小时时，状态一直很正常，正在和粉丝互动聊家常。然而就在凌晨1点左右，主播的手机连续震动多次，其表情明显变得紧张。在接听了一个约30秒的电话后，该主播面色铁青，仅说了一句"有点急事，先下了"便匆匆关闭了直播。</p>
    <p>这一突如其来的下播行为让数百万在线观众陷入困惑。随后不到半小时，相关话题便冲上了各大社交平台的热搜榜。</p>
    <h2>金主身份浮出水面</h2>
    <p>随着事件的持续发酵，有匿名知情人士向本网提供了关键线索。据透露，该网红背后的"金主"实为某知名娱乐公司的幕后资本方，双方存在长期利益绑定关系。该网红所谓的"白手起家"、"独立创业"人设，实际上全程由资本方包装打造。</p>
    <p>更令人震惊的是，该网红此前多次在公开场合宣扬的"草根逆袭"故事，被证实存在大量虚构和夸大成分。其宣称的年收入数据、创业经历均有严重造假嫌疑。</p>
    <h2>合同欺诈疑云</h2>
    <p>除了人设造假外，该网红还面临合同欺诈的指控。多位与其有过商业合作的品牌方透露，该网红在签约时提供的粉丝数据、转化率等关键指标存在严重注水现象。目前已有多家品牌方表示将采取法律手段维权。</p>
    <p>一位不愿透露姓名的品牌方代表告诉记者："我们当初选择合作，就是因为看中了他的真实粉丝基础。但现在看来，那些数据可能都是假的。这对我们品牌造成了很大的损失。"</p>
    <h2>粉丝反应两极分化</h2>
    <p>面对铺天盖地的爆料，该网红的粉丝群体出现了明显的分裂。一部分死忠粉坚持认为这是有人在故意抹黑，表示会一直支持偶像。而另一部分粉丝则感到深深的被欺骗感，纷纷在评论区表达失望和愤怒。</p>
    <p>"我关注了他三年，每个月都给他刷礼物，没想到全是假的。"一位资深粉丝在社交平台上写道。</p>
    <h2>后续发展</h2>
    <p>截至目前，该网红及其团队尚未对上述爆料做出正式回应。其社交账号自事发当晚以来一直处于停更状态。业内人士分析认为，如果上述指控属实，该网红将面临严重的信任危机和商业损失，其职业生涯或将就此终结。</p>
    <p>本网将持续关注此事的最新进展，为读者带来第一手的报道。</p>
  `,
  relatedArticles: [
    { id: "article-5", title: "某直播平台头部主播涉嫌数据造假，后台截图被内部员工泄露", excerpt: "截图显示该主播直播间真实在线人数不足显示的十分之一，大量弹幕由机器人自动发送。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20computer%20screen%20in%20a%20dimly%20lit%20room%2C%20abstract%20data%20charts%20and%20numbers%20glowing%20in%20amber%20light%2C%20warm%20dark%20tones%2C%20cinematic%20atmosphere%20with%20deep%20shadows%2C%20editorial%20photography%20style&width=800&height=600&seq=related-01&orientation=landscape", date: "2026-07-04" },
    { id: "article-4", title: "某女团成员私下吸烟喝酒照曝光，清纯人设彻底崩塌", excerpt: "照片拍摄于某私人聚会，该成员与多名男性友人举止亲密。经纪公司已宣布暂停其所有演艺活动。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20private%20party%20scene%20with%20warm%20candlelight%20and%20deep%20shadows%2C%20abstract%20silhouettes%20of%20people%20socializing%2C%20burgundy%20and%20amber%20color%20palette%2C%20cinematic%20moody%20photography&width=800&height=600&seq=related-02&orientation=landscape", date: "2026-07-05" },
  ],
};

const a2: ArticleDetailData = {
  id: "article-2",
  title: "某顶流男星夜店私密视频外泄，工作室紧急发声明否认",
  titleLine1: "顶流男星",
  titleLine2: "夜店私密视频",
  titleLine3: "工作室紧急否认",
  excerpt: "视频中疑似该男星与多名女子亲密互动，画面尺度极大。粉丝后援会已组织大规模控评行动，但网友已截图保存。",
  category: "明星黑料",
  categorySlug: "celebrity-scandal",
  tag: "网曝门",
  date: "2026-07-06",
  views: "256.3万",
  source: "51吃瓜黑料编辑部",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Moody%20nightclub%20interior%20with%20deep%20amber%20and%20crimson%20neon%20lights%2C%20abstract%20blurred%20figures%20in%20the%20background%2C%20dramatic%20atmosphere%2C%20warm%20dark%20tones%2C%20cinematic%20photography%20with%20lens%20flare%20and%20soft%20focus%2C%20editorial%20style&width=1600&height=900&seq=article-hero-02&orientation=landscape",
  contentHtml: `
    <p>近日，一段据称是某顶流男星在夜店狂欢的私密视频在网络上疯传。视频画面虽然昏暗，但可清晰辨认出该男星与多名女子举止亲密，尺度之大令人瞠目。</p>
    <h2>视频来源成谜</h2>
    <p>据追踪，该视频最早出现在某匿名社交平台，随后被大量转发至微博、抖音等主流平台。尽管发布者很快删除了原始内容，但已有大量网友完成截图和录屏保存。目前尚不清楚视频的具体拍摄时间和泄露源头。</p>
    <p>有网友分析，视频拍摄角度十分隐蔽，很可能是夜店内部工作人员偷拍。也有观点认为，这可能是竞争对手的有意抹黑行为。</p>
    <h2>工作室紧急声明</h2>
    <p>事件发酵后，该男星的工作室于次日凌晨紧急发布声明，称视频内容"纯属捏造"，系"恶意剪辑和AI换脸技术合成"，并表示已委托律师团队收集证据，将通过法律途径追究造谣者的责任。</p>
    <p>然而，该声明未能平息公众质疑。多位视频技术专家分析后认为，视频画面流畅自然，不存在明显的AI合成痕迹。</p>
    <h2>粉丝后援会大规模控评</h2>
    <p>在工作室发布声明的同时，该男星的粉丝后援会迅速组织了大规模的控评行动。各大社交平台的相关话题下，大量粉丝统一发布"已取证，等律师函"、"清者自清"等评论，试图淡化事件影响。</p>
    <p>但这种控评行为引发了吃瓜群众的反感，不少网友开始自发"反控评"，相关话题热度不降反升。</p>
    <h2>品牌方态度微妙</h2>
    <p>据业内人士透露，与该男星有代言合作的多个品牌方正在密切关注事态发展。一家国际奢侈品牌的公关负责人私下表示，如果事件持续发酵，将考虑暂停与该男星的合作。</p>
    <p>本网将持续关注此事进展。</p>
  `,
  relatedArticles: [
    { id: "article-4", title: "某女团成员私下吸烟喝酒照曝光，清纯人设彻底崩塌", excerpt: "照片拍摄于某私人聚会，该成员与多名男性友人举止亲密。经纪公司已宣布暂停其所有演艺活动。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20private%20party%20scene%20with%20warm%20candlelight%20and%20deep%20shadows%2C%20abstract%20silhouettes%20of%20people%20socializing%2C%20burgundy%20and%20amber%20color%20palette%2C%20cinematic%20moody%20photography&width=800&height=600&seq=related-03&orientation=landscape", date: "2026-07-05" },
    { id: "article-8", title: "知名演员被曝税务问题，多个代言品牌紧急解约切割", excerpt: "据税务部门内部消息，该演员涉嫌偷逃税款金额高达数千万元。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20luxury%20office%20interior%20with%20amber%20lighting%2C%20abstract%20documents%20on%20desk%2C%20warm%20tones%2C%20cinematic%20style&width=800&height=600&seq=related-04&orientation=landscape", date: "2026-07-03" },
  ],
};

const a3: ArticleDetailData = {
  id: "article-3",
  title: "知名美食博主被曝人设造假，私底下竟靠代拍年入千万",
  titleLine1: "知名美食博主",
  titleLine2: "人设造假",
  titleLine3: "代拍年入千万",
  excerpt: "该博主以'真实的日常生活'走红，却被前助理爆出所有内容均有剧本。其真实身份为某MCN机构幕后股东。",
  category: "博主反差",
  categorySlug: "blogger-contrast",
  tag: "反差记录",
  date: "2026-07-05",
  views: "89.2万",
  source: "51吃瓜黑料编辑部",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20a%20modern%20kitchen%20studio%20setup%20with%20professional%20lighting%20equipment%2C%20warm%20amber%20tones%2C%20dramatic%20shadows%2C%20abstract%20composition%20with%20food%20props%20scattered%2C%20editorial%20photography%20style%2C%20tense%20atmosphere&width=1600&height=900&seq=article-hero-03&orientation=landscape",
  contentHtml: `
    <p>以"真实的日常生活"走红的美食博主，近日被前助理实名爆料称其所有视频内容均为精心设计的剧本。这一爆料在美食博主圈引发了巨大震动。</p>
    <h2>前助理实名爆料</h2>
    <p>这位自称担任该博主助理长达两年的爆料者表示，博主所谓的"在家随手拍的日常"其实每一个镜头都经过了反复彩排。厨房场景是专门租用的拍摄场地，食材由团队统一采购布置，"美味"的评价也是提前写好的台词。</p>
    <p>"她说自己不会做饭是节目效果，其实她做的那些菜难度很高，都是请专业厨师演示后，她再模仿拍摄的。"前助理在爆料长文中写道。</p>
    <h2>真实身份曝光</h2>
    <p>更令人震惊的是，通过对工商注册信息的查询，该博主实为某知名MCN机构的幕后大股东。她一方面以"独立创作者"的身份获取粉丝信任，一方面通过旗下签约的几十位博主进行大规模商业变现。</p>
    <p>统计数据显示，仅去年一年，其通过代拍、广告分成、电商带货等方式获得的收入就超过千万。</p>
    <h2>商业合作面临危机</h2>
    <p>事件曝光后，多个与该博主合作的调味品品牌、厨房电器品牌纷纷宣布暂停合作。一家知名厨具品牌的负责人表示，当初选择合作正是因为看中其"真实"的形象定位。</p>
    <p>"如果早知道这一切都是演的，我们绝不会投入这么多预算。"该负责人说。</p>
    <h2>行业反思</h2>
    <p>此事件也引发了整个美食博主行业的反思。多位业内人士呼吁平台方加强对创作者内容的真实性审核，建立更透明的商业合作机制。</p>
    <p>本网将持续关注此事最新进展。</p>
  `,
  relatedArticles: [
    { id: "article-6", title: "某知名夫妻档博主被爆已离婚半年，共同账号实为商业合约", excerpt: "据圈内人士透露，二人早在去年底就已办理离婚手续，但因广告合约未到期一直维持假恩爱形象。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20two%20separated%20figures%20in%20a%20luxurious%20modern%20living%20room%2C%20warm%20amber%20lighting%20with%20deep%20shadows%2C%20emotional%20distance%20atmosphere%2C%20editorial%20photography%20style%2C%20moody%20composition%20with%20dramatic%20contrast&width=800&height=600&seq=related-05&orientation=landscape", date: "2026-07-04" },
    { id: "article-9", title: "某育儿博主被质疑虐待儿童，警方已介入调查取证", excerpt: "多段视频显示该博主在拍摄过程中对儿童有不当行为。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20children%20room%20with%20warm%20amber%20lighting%2C%20tense%20atmosphere%2C%20cinematic%20photography%20style&width=800&height=600&seq=related-06&orientation=landscape", date: "2026-07-02" },
  ],
};

const a4: ArticleDetailData = {
  id: "article-4",
  title: "某女团成员私下吸烟喝酒照曝光，清纯人设彻底崩塌",
  titleLine1: "女团成员",
  titleLine2: "私下吸烟喝酒",
  titleLine3: "清纯人设崩塌",
  excerpt: "照片拍摄于某私人聚会，该成员与多名男性友人举止亲密。经纪公司已宣布暂停其所有演艺活动。",
  category: "明星黑料",
  categorySlug: "celebrity-scandal",
  tag: "独家爆料",
  date: "2026-07-05",
  views: "342.1万",
  source: "51吃瓜黑料编辑部",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20private%20party%20scene%20with%20warm%20candlelight%20and%20deep%20shadows%2C%20abstract%20silhouettes%20of%20people%20socializing%2C%20burgundy%20and%20amber%20color%20palette%2C%20cinematic%20moody%20photography%20with%20dramatic%20lighting%2C%20editorial%20style&width=1600&height=900&seq=article-hero-04&orientation=landscape",
  contentHtml: `
    <p>一组据称是某当红女团成员的私下聚会照片在网络上疯狂传播。照片中该成员手拿香烟、端酒杯与多名男性亲密互动的画面，与其在舞台上塑造的"清纯少女"形象形成了巨大反差。</p>
    <h2>照片细节分析</h2>
    <p>根据照片中的背景装潢和桌上的品牌酒水判断，聚会地点疑似为某高端私人会所。照片拍摄时间大约在凌晨两点左右，该成员身穿与公开场合截然不同的性感服装，神情放松自然，显然已多次出入此类场合。</p>
    <p>值得注意的是，与她在合照的多名男性身份也引起了网友的热议。有人指认其中一位为某娱乐公司高层，另有一位被认出是圈内有名的"玩咖"二代。</p>
    <h2>经纪公司火速处理</h2>
    <p>照片曝光后不到六小时，该女团所属经纪公司便发布公告，宣布暂停该成员的所有演艺活动，包括即将播出的综艺节目录制和品牌代言。公司声明称将"严肃调查此事"，并"保留追究恶意传播者法律责任的权利"。</p>
    <p>业内人士分析，经纪公司的快速反应说明其已确认了照片的真实性，所谓的"调查"更多是给公众和合作方一个交代。</p>
    <h2>粉丝反应</h2>
    <p>该成员的个人应援站已有多个宣布关闭。大量粉丝在社交平台表达失望和愤怒，认为被欺骗了多年的感情。但也有部分粉丝表示"艺人也需要私人空间"，呼吁外界给予理解和包容。</p>
    <p>本网将持续关注此事后续发展。</p>
  `,
  relatedArticles: [
    { id: "article-2", title: "某顶流男星夜店私密视频外泄，工作室紧急发声明否认", excerpt: "视频中疑似该男星与多名女子亲密互动，画面尺度极大。", imageUrl: "https://readdy.ai/api/search-image?query=Moody%20nightclub%20interior%20with%20deep%20amber%20and%20crimson%20neon%20lights%2C%20abstract%20blurred%20figures%2C%20dramatic%20atmosphere%2C%20warm%20dark%20tones%2C%20cinematic%20photography&width=800&height=600&seq=related-07&orientation=landscape", date: "2026-07-06" },
    { id: "article-8", title: "知名演员被曝税务问题，多个代言品牌紧急解约切割", excerpt: "据税务部门内部消息，该演员涉嫌偷逃税款金额高达数千万元。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20luxury%20office%20interior%20with%20amber%20lighting%2C%20abstract%20documents%20on%20desk%2C%20warm%20tones%2C%20cinematic%20style&width=800&height=600&seq=related-08&orientation=landscape", date: "2026-07-03" },
  ],
};

const a5: ArticleDetailData = {
  id: "article-5",
  title: "某直播平台头部主播涉嫌数据造假，后台截图被内部员工泄露",
  titleLine1: "直播平台头部主播",
  titleLine2: "数据造假",
  titleLine3: "后台截图泄露",
  excerpt: "截图显示该主播直播间真实在线人数不足显示的十分之一，大量弹幕由机器人自动发送。平台方暂未回应。",
  category: "网红塌房",
  categorySlug: "influencer-scandal",
  tag: "网曝门",
  date: "2026-07-04",
  views: "176.8万",
  source: "51吃瓜黑料编辑部",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20computer%20screen%20in%20a%20dimly%20lit%20room%2C%20abstract%20data%20charts%20and%20numbers%20glowing%20in%20amber%20light%2C%20warm%20dark%20tones%2C%20cinematic%20atmosphere%20with%20deep%20shadows%2C%20editorial%20photography%20style%2C%20mysterious%20composition&width=1600&height=900&seq=article-hero-05&orientation=landscape",
  contentHtml: `
    <p>一张据称是某直播平台后台管理系统的截图在网络上疯传，截图清晰显示了一位头部主播直播间的真实数据情况——在线人数仅为对外显示的十分之一。</p>
    <h2>后台截图曝光</h2>
    <p>泄露的截图来自该直播平台的内部数据管理系统。从截图上可以清楚看到，该主播某场直播对外显示的在线人数为120万，但后台真实数据仅为9.7万。此外，截图还显示该直播间的弹幕有超过80%由机器人自动生成和发送。</p>
    <p>据分析，这张截图的泄露者很可能是该平台的一名内部员工。截图的拍摄时间大约在凌晨3点，此时正是平台夜班运维人员的值班时段。</p>
    <h2>数据造假产业链</h2>
    <p>业内人士透露，直播数据造假已经形成了一条完整的灰色产业链。从机器人弹幕、虚假在线人数到刷礼物、刷榜单，每一项都有专门的服务商提供技术支持。</p>
    <p>"一个拥有百万粉丝的主播，月均花费在数据维护上的费用可能高达几十万元。"一位不愿透露姓名的MCN机构运营表示。</p>
    <h2>平台方沉默应对</h2>
    <p>截至目前，涉事直播平台尚未对此事件做出正式回应。有分析认为，平台方之所以保持沉默，是因为数据造假问题涉及平台自身的核心商业利益，一旦承认将引发连锁反应。</p>
    <p>本网将持续关注此事件的最新进展。</p>
  `,
  relatedArticles: [
    { id: "article-1", title: "某千万粉网红深夜直播翻车，背后金主身份遭实锤曝光", excerpt: "据知情人士透露，该网红与多位娱乐圈资本大佬关系密切。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20cinematic%20scene%20of%20a%20streaming%20studio%20with%20dramatic%20red%20and%20amber%20lighting%2C%20abstract%20silhouette%2C%20warm%20dark%20tones%2C%20editorial%20photography%20style&width=800&height=600&seq=related-09&orientation=landscape", date: "2026-07-06" },
    { id: "article-7", title: "某健身网红被扒真实身材全靠修图，线下偶遇照差距惊人", excerpt: "网友偶遇拍到的照片与社交平台发布的精修图判若两人。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20gym%20interior%20with%20warm%20amber%20lighting%2C%20abstract%20figure%20silhouette%2C%20contrast%20theme%2C%20cinematic%20style&width=800&height=600&seq=related-10&orientation=landscape", date: "2026-07-03" },
  ],
};

const a6: ArticleDetailData = {
  id: "article-6",
  title: "某知名夫妻档博主被爆已离婚半年，共同账号实为商业合约",
  titleLine1: "知名夫妻档博主",
  titleLine2: "已离婚半年",
  titleLine3: "共同账号实为商业合约",
  excerpt: "据圈内人士透露，二人早在去年底就已办理离婚手续，但因广告合约未到期一直维持假恩爱形象。",
  category: "博主反差",
  categorySlug: "blogger-contrast",
  tag: "反差记录",
  date: "2026-07-04",
  views: "203.5万",
  source: "51吃瓜黑料编辑部",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20two%20separated%20figures%20in%20a%20luxurious%20modern%20living%20room%2C%20warm%20amber%20lighting%20with%20deep%20shadows%2C%20emotional%20distance%20atmosphere%2C%20editorial%20photography%20style%2C%20moody%20composition%20with%20dramatic%20contrast&width=1600&height=900&seq=article-hero-06&orientation=landscape",
  contentHtml: `
    <p>曾被誉为"全网最甜夫妻"的某知名夫妻档博主，被圈内人士爆料已秘密离婚超过半年。而两人在社交平台上持续更新的"甜蜜日常"，实际上是为了履行尚未到期的商业广告合约。</p>
    <h2>离婚时间线曝光</h2>
    <p>据知情人士透露，这对夫妻档博主实际上去年12月就已经在民政局办理了离婚手续。但由于当时有多个品牌代言合约尚未到期，双方协商决定对外维持"恩爱夫妻"的形象。</p>
    <p>"所有签约合同里都有'形象维护条款'，如果因为个人原因导致形象受损影响品牌方利益的，需要赔付巨额违约金。"知情人士解释。</p>
    <h2>商业利益高于感情</h2>
    <p>据估算，这对夫妻档账号的年广告收入超过两千万。其中约70%的收入来自"恩爱夫妻"相关品类——包括婚庆策划、情侣服饰、家居用品等。一旦离婚消息公开，这些商业合作将在短期内全部中断。</p>
    <p>目前两人仍在各自的社交账号上按照既定排期发布"恩爱"内容，但眼尖的粉丝已经发现了诸多不自然的细节——比如两人近期从未同框出镜，所有合照均为旧图。</p>
    <h2>粉丝态度</h2>
    <p>面对这一爆料，大量粉丝表示"早有预感但不愿相信"。也有不少粉丝愤怒地表示："为了赚钱欺骗粉丝的感情，这种行为比离婚本身更让人失望。"</p>
    <p>本网将持续关注此事进展。</p>
  `,
  relatedArticles: [
    { id: "article-3", title: "知名美食博主被曝人设造假，私底下竟靠代拍年入千万", excerpt: "该博主以'真实的日常生活'走红，却被前助理爆出所有内容均有剧本。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20a%20modern%20kitchen%20studio%20setup%20with%20professional%20lighting%20equipment%2C%20warm%20amber%20tones%2C%20dramatic%20shadows%2C%20editorial%20photography%20style&width=800&height=600&seq=related-11&orientation=landscape", date: "2026-07-05" },
    { id: "article-9", title: "某育儿博主被质疑虐待儿童，警方已介入调查取证", excerpt: "多段视频显示该博主在拍摄过程中对儿童有不当行为。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20children%20room%20with%20warm%20amber%20lighting%2C%20tense%20atmosphere%2C%20cinematic%20photography%20style&width=800&height=600&seq=related-12&orientation=landscape", date: "2026-07-02" },
  ],
};

const a7: ArticleDetailData = {
  id: "article-7",
  title: "某健身网红被扒真实身材全靠修图，线下偶遇照差距惊人",
  titleLine1: "健身网红",
  titleLine2: "身材全靠修图",
  titleLine3: "线下偶遇差距惊人",
  excerpt: "网友偶遇拍到的照片与社交平台发布的精修图判若两人，引发全网热议。",
  category: "网红塌房",
  categorySlug: "influencer-scandal",
  tag: "反差记录",
  date: "2026-07-03",
  views: "95.3万",
  source: "51吃瓜黑料编辑部",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20gym%20interior%20with%20warm%20amber%20lighting%2C%20abstract%20figure%20silhouette%20in%20mirror%20reflection%2C%20contrast%20and%20comparison%20theme%2C%20cinematic%20photography%20style%20with%20dramatic%20shadows%2C%20editorial%20composition&width=1600&height=900&seq=article-hero-07&orientation=landscape",
  contentHtml: `
    <p>一位拥有数百万粉丝的健身博主近日遭遇了人设滑铁卢。一名网友在健身房偶遇该博主后拍下照片，与博主社交平台上的精修图对比，差距之大令人震惊。</p>
    <h2>偶遇照vs精修图</h2>
    <p>从网友提供的偶遇照片来看，该博主真实身材远不如其社交平台上展示的那般完美。腹肌线条模糊不清，手臂围度也比照片中小了一圈。而在同一天该博主发布的打卡照中，画面里的他肌肉线条分明，八块腹肌清晰可见。</p>
    <p>专业PS人士分析后指出，该博主的照片经过了多道后期处理——包括液化瘦腰、加深肌肉线条、调整光影对比等多项技术手段。</p>
    <h2>带货产品遭质疑</h2>
    <p>更引发争议的是，该博主一直在大力推广多款健身补剂和训练课程，声称这些产品和课程帮助他获得了现在的身材。大量粉丝在购买后发现效果远不如预期，如今看到真实照片后更是愤怒不已。</p>
    <p>"我花了三千多买他的线上课程，练了半年还不如他说的一周效果。"一位受骗粉丝在投诉平台上写道。</p>
    <h2>行业乱象</h2>
    <p>健身博主修图并非个别现象。多位业内人士承认，在健身自媒体行业，几乎所有头部博主的照片都经过不同程度的后期处理。有的甚至请了专业修图师全职负责内容美化。</p>
    <p>本网呼吁广大消费者理性看待网络内容，谨慎购买网红带货产品。</p>
  `,
  relatedArticles: [
    { id: "article-5", title: "某直播平台头部主播涉嫌数据造假，后台截图被内部员工泄露", excerpt: "截图显示该主播直播间真实在线人数不足显示的十分之一。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20computer%20screen%20in%20a%20dimly%20lit%20room%2C%20abstract%20data%20charts%20and%20numbers%20glowing%20in%20amber%20light%2C%20warm%20dark%20tones%2C%20cinematic%20atmosphere&width=800&height=600&seq=related-13&orientation=landscape", date: "2026-07-04" },
    { id: "article-1", title: "某千万粉网红深夜直播翻车，背后金主身份遭实锤曝光", excerpt: "据知情人士透露，该网红与多位娱乐圈资本大佬关系密切。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20cinematic%20scene%20of%20a%20streaming%20studio%20with%20dramatic%20red%20and%20amber%20lighting%2C%20abstract%20silhouette%2C%20warm%20dark%20tones&width=800&height=600&seq=related-14&orientation=landscape", date: "2026-07-06" },
  ],
};

const a8: ArticleDetailData = {
  id: "article-8",
  title: "知名演员被曝税务问题，多个代言品牌紧急解约切割",
  titleLine1: "知名演员",
  titleLine2: "税务问题曝光",
  titleLine3: "品牌紧急解约",
  excerpt: "据税务部门内部消息，该演员涉嫌偷逃税款金额高达数千万元。目前已有多家代言品牌宣布与其解约。",
  category: "明星黑料",
  categorySlug: "celebrity-scandal",
  tag: "独家爆料",
  date: "2026-07-03",
  views: "489.7万",
  source: "51吃瓜黑料编辑部",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20luxury%20office%20interior%20with%20amber%20lighting%2C%20abstract%20documents%20and%20contracts%20scattered%20on%20desk%2C%20tense%20business%20atmosphere%2C%20warm%20tones%2C%20cinematic%20photography%20style%20with%20dramatic%20shadows&width=1600&height=900&seq=article-hero-08&orientation=landscape",
  contentHtml: `
    <p>娱乐圈税务风暴再度来袭。据税务部门内部人士透露，一位拥有多个国际品牌代言的知名演员因涉嫌严重偷逃税款正在接受调查，涉案金额高达数千万元。</p>
    <h2>税务问题细节</h2>
    <p>据悉，该演员通过设立多家空壳公司、签订阴阳合同、虚报成本等方式，在过去三年内偷逃个人所得税及增值税合计超过三千万元。税务部门已经掌握了完整的证据链。</p>
    <p>值得注意的是，该演员此前曾多次在公开场合发表"艺人应该依法纳税"的言论，如今看来不免讽刺。</p>
    <h2>品牌方紧急切割</h2>
    <p>消息传出后，与该演员有代言合作的多个国内外品牌迅速做出反应。截至目前，已有五家品牌通过官方渠道宣布与该演员解除合作关系。一家国际奢侈品牌的声明中写道："我们高度重视合作伙伴的诚信与合规性。"</p>
    <p>据估算，此次解约将给该演员带来超过亿元的代言费损失。</p>
    <h2>尚未播出的作品受影响</h2>
    <p>该演员还有三部影视作品处于后期制作阶段，总投资额超过五亿元。如果税务问题最终被确认，这些作品可能面临无法正常播出的风险，投资方将遭受巨大损失。</p>
    <p>本网将持续关注此事最新进展。</p>
  `,
  relatedArticles: [
    { id: "article-2", title: "某顶流男星夜店私密视频外泄，工作室紧急发声明否认", excerpt: "视频中疑似该男星与多名女子亲密互动，画面尺度极大。", imageUrl: "https://readdy.ai/api/search-image?query=Moody%20nightclub%20interior%20with%20deep%20amber%20and%20crimson%20neon%20lights%2C%20abstract%20blurred%20figures%2C%20dramatic%20atmosphere&width=800&height=600&seq=related-15&orientation=landscape", date: "2026-07-06" },
    { id: "article-4", title: "某女团成员私下吸烟喝酒照曝光，清纯人设彻底崩塌", excerpt: "照片拍摄于某私人聚会，该成员与多名男性友人举止亲密。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20private%20party%20scene%20with%20warm%20candlelight%20and%20deep%20shadows%2C%20abstract%20silhouettes%2C%20burgundy%20and%20amber%20color%20palette&width=800&height=600&seq=related-16&orientation=landscape", date: "2026-07-05" },
  ],
};

const a9: ArticleDetailData = {
  id: "article-9",
  title: "某育儿博主被质疑虐待儿童，警方已介入调查取证",
  titleLine1: "育儿博主",
  titleLine2: "被质疑虐待儿童",
  titleLine3: "警方介入调查",
  excerpt: "多段视频显示该博主在拍摄过程中对儿童有不当行为。网友已向网信办和公安机关举报，事件引发社会广泛关注。",
  category: "博主反差",
  categorySlug: "blogger-contrast",
  tag: "网曝门",
  date: "2026-07-02",
  views: "567.3万",
  source: "51吃瓜黑料编辑部",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20children%20room%20with%20warm%20amber%20lighting%2C%20tense%20and%20unsettling%20atmosphere%2C%20abstract%20composition%20suggesting%20concern%20and%20protection%2C%20cinematic%20photography%20style%20with%20dramatic%20contrast%20and%20deep%20shadows&width=1600&height=900&seq=article-hero-09&orientation=landscape",
  contentHtml: `
    <p>一位拥有数百万粉丝的育儿博主近日被推上了舆论的风口浪尖。多位网友从其发布的大量视频中剪辑出多段疑似虐待儿童的画面，并向网信办和公安机关进行了举报。</p>
    <h2>争议视频内容</h2>
    <p>被网友指出的问题视频中，有一段显示该博主在拍摄过程中对哭闹的孩子大声呵斥，甚至用力推搡。还有一段视频中，孩子在高温天气下被要求反复拍摄同一场景，直至中暑才被送往医院。</p>
    <p>"这不是育儿，这分明是在利用孩子博流量。"一位举报者在社交平台上写道。</p>
    <h2>警方介入</h2>
    <p>事件发酵后，当地公安机关已正式受理举报并介入调查。据知情人士透露，警方已调取了该博主账号的全部视频内容，并传唤了相关人员进行询问。</p>
    <p>如果虐待儿童的指控最终被证实，该博主将面临行政处罚甚至刑事追诉。</p>
    <h2>平台方下架内容</h2>
    <p>多个短视频平台已暂时下架了该博主的所有内容。平台方在声明中表示："我们对任何形式的儿童虐待行为零容忍。在调查期间，将暂停该账号的所有功能。"</p>
    <p>本网将持续关注此事调查结果。</p>
  `,
  relatedArticles: [
    { id: "article-6", title: "某知名夫妻档博主被爆已离婚半年，共同账号实为商业合约", excerpt: "据圈内人士透露，二人早在去年底就已办理离婚手续。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20two%20separated%20figures%20in%20a%20luxurious%20modern%20living%20room%2C%20warm%20amber%20lighting%20with%20deep%20shadows%2C%20emotional%20distance%20atmosphere&width=800&height=600&seq=related-17&orientation=landscape", date: "2026-07-04" },
    { id: "article-3", title: "知名美食博主被曝人设造假，私底下竟靠代拍年入千万", excerpt: "该博主以'真实的日常生活'走红，却被前助理爆出所有内容均有剧本。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20a%20modern%20kitchen%20studio%20setup%20with%20professional%20lighting%20equipment%2C%20warm%20amber%20tones%2C%20dramatic%20shadows&width=800&height=600&seq=related-18&orientation=landscape", date: "2026-07-05" },
  ],
};

const a10: ArticleDetailData = {
  id: "article-10",
  title: "某知名企业高管群聊记录外泄，内部黑暗操作全曝光",
  titleLine1: "知名企业高管",
  titleLine2: "群聊记录外泄",
  titleLine3: "内部操作全曝光",
  excerpt: "聊天记录涉及价格垄断、商业贿赂等多重违法内容。事件已引起市场监管部门的高度关注。",
  category: "网曝门事件",
  categorySlug: "exposure-gate",
  tag: "独家爆料",
  date: "2026-07-06",
  views: "678.2万",
  source: "51吃瓜黑料编辑部",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20with%20amber%20lighting%2C%20abstract%20phone%20screen%20glowing%20with%20message%20notifications%2C%20tense%20and%20secretive%20atmosphere%2C%20cinematic%20photography%20style%20with%20dramatic%20shadows%2C%20editorial%20composition&width=1600&height=900&seq=article-hero-10&orientation=landscape",
  contentHtml: `
    <p>一组据称是某知名企业高管内部群聊的截图在网络上大规模传播。聊天内容之劲爆，涉及商业操作的黑暗程度之深，令吃瓜群众大开眼界。</p>
    <h2>群聊内容曝光</h2>
    <p>泄露的群聊记录长达数百页，时间跨度超过两年。聊天内容显示，该企业高管团队在群内公然讨论如何与竞争对手达成价格同盟、如何通过贿赂获取政府项目、以及如何利用虚假宣传误导消费者。</p>
    <p>一段聊天记录中，一位高管写道："找个靠谱的关系，这个项目必须拿下，预算不是问题。"另一段记录则显示，该企业将过期产品重新包装后继续销售。</p>
    <h2>监管部门介入</h2>
    <p>事件引起广泛关注后，国家市场监督管理总局已表示将对此事进行调查。如果群聊记录中的内容被证实，该企业将面临巨额罚款，相关责任人可能面临刑事追诉。</p>
    <p>法律专家分析认为，该群聊记录涉及的问题至少触犯了《反垄断法》、《反不正当竞争法》和《食品安全法》三部法律。</p>
    <h2>股价暴跌</h2>
    <p>受此事件影响，该企业股价在消息传出后暴跌超过30%，市值一夜蒸发数百亿。大量投资者纷纷表示将追究企业信息披露不实的责任。</p>
    <p>本网将持续关注监管部门的最新调查进展。</p>
  `,
  relatedArticles: [
    { id: "article-12", title: "某电商平台双十一数据造假内幕被前员工实名举报", excerpt: "举报材料详细记录了平台如何通过技术手段虚增GMV数据。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20warehouse%20interior%20with%20warm%20amber%20lighting%2C%20packages%20and%20boxes%20scattered%2C%20cinematic%20style%2C%20editorial%20photography&width=800&height=600&seq=related-19&orientation=landscape", date: "2026-07-04" },
    { id: "article-11", title: "某综艺节目导演组内部音频流出，剧本安排细节曝光", excerpt: "音频清晰记录了导演组如何设计冲突情节和安排选手淘汰顺序。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20TV%20studio%20control%20room%20with%20warm%20amber%20monitors%2C%20cinematic%20atmosphere%2C%20editorial%20style&width=800&height=600&seq=related-20&orientation=landscape", date: "2026-07-05" },
  ],
};

const a11: ArticleDetailData = {
  id: "article-11",
  title: "某综艺节目导演组内部音频流出，剧本安排细节曝光",
  titleLine1: "综艺节目导演组",
  titleLine2: "内部音频流出",
  titleLine3: "剧本安排细节曝光",
  excerpt: "音频清晰记录了导演组如何设计冲突情节和安排选手淘汰顺序。观众直呼被骗，节目公信力面临严重危机。",
  category: "网曝门事件",
  categorySlug: "exposure-gate",
  tag: "网曝门",
  date: "2026-07-05",
  views: "345.6万",
  source: "51吃瓜黑料编辑部",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20TV%20studio%20control%20room%20with%20multiple%20warm%20amber%20monitors%20glowing%2C%20professional%20broadcast%20equipment%2C%20secretive%20behind-the-scenes%20atmosphere%2C%20cinematic%20photography%20style%20with%20dramatic%20shadows%2C%20editorial%20composition&width=1600&height=900&seq=article-hero-11&orientation=landscape",
  contentHtml: `
    <p>一段据称是某热门综艺节目导演组内部会议音频的录音在网络上流传。长达两小时的录音中，导演组详细讨论了如何"设计"每一期的冲突情节和淘汰人选，完全颠覆了节目宣传的"真实记录"定位。</p>
    <h2>剧本细节触目惊心</h2>
    <p>录音中，总导演明确表示："这一期必须要有哭点，安排A和B吵一架，最好能吵到哭。"另一位导演则建议："让C在台上突然崩溃，我们切特写，这期热搜就有了。"</p>
    <p>更令人震惊的是，选手淘汰顺序早在节目录制前就已确定。一位导演组成员在会议中说："D的品牌方已经打过招呼了，至少让他进前五。E没什么商业价值，下周就可以淘汰了。"</p>
    <h2>观众愤怒</h2>
    <p>音频流出后，该节目的忠实观众感到极度愤怒。"我们每周熬夜投票、花钱买礼物支持喜欢的选手，结果一切早就定好了？这就是赤裸裸的诈骗！"一位观众在评论区写道。</p>
    <p>多个消费者权益保护组织表示将关注此事，如果节目存在诱导消费行为，将依法追究相关责任。</p>
    <h2>节目组回应</h2>
    <p>节目组在事件发酵后发布声明，称音频系"恶意剪辑合成"，并已向公安机关报案。但声明中并未正面回应音频中的具体内容是否属实。</p>
    <p>本网将持续关注此事进展。</p>
  `,
  relatedArticles: [
    { id: "article-10", title: "某知名企业高管群聊记录外泄，内部黑暗操作全曝光", excerpt: "聊天记录涉及价格垄断、商业贿赂等多重违法内容。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20with%20amber%20lighting%2C%20abstract%20phone%20screen%20glowing%2C%20tense%20and%20secretive%20atmosphere%2C%20cinematic%20style&width=800&height=600&seq=related-21&orientation=landscape", date: "2026-07-06" },
    { id: "article-12", title: "某电商平台双十一数据造假内幕被前员工实名举报", excerpt: "举报材料详细记录了平台如何通过技术手段虚增GMV数据。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20warehouse%20interior%20with%20warm%20amber%20lighting%2C%20packages%2C%20cinematic%20style%2C%20editorial%20photography&width=800&height=600&seq=related-22&orientation=landscape", date: "2026-07-04" },
  ],
};

const a12: ArticleDetailData = {
  id: "article-12",
  title: "某电商平台双十一数据造假内幕被前员工实名举报",
  titleLine1: "电商平台",
  titleLine2: "双十一数据造假",
  titleLine3: "前员工实名举报",
  excerpt: "举报材料详细记录了平台如何通过技术手段虚增GMV数据。市场监管部门已正式立案调查，平台方尚未回应。",
  category: "网曝门事件",
  categorySlug: "exposure-gate",
  tag: "独家爆料",
  date: "2026-07-04",
  views: "234.8万",
  source: "51吃瓜黑料编辑部",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dark%20warehouse%20and%20logistics%20center%20interior%20with%20warm%20amber%20lighting%2C%20packages%20and%20shipping%20boxes%20stacked%2C%20data%20screens%20glowing%2C%20tense%20corporate%20atmosphere%2C%20cinematic%20photography%20style%20with%20dramatic%20shadows%2C%20editorial%20composition&width=1600&height=900&seq=article-hero-12&orientation=landscape",
  contentHtml: `
    <p>一位自称在某大型电商平台工作多年的前员工，以实名方式向媒体提交了一份详细的举报材料，揭露了该平台在历年双十一大促期间系统性数据造假的内幕。</p>
    <h2>造假手段揭秘</h2>
    <p>根据举报材料描述，该平台的数据造假手段主要包括以下几种：一是通过技术手段在后台自动生成虚假订单，在活动结束后再统一取消；二是将常规月份的订单数据集中归入双十一当天；三是与合作商家约定"刷单返现"，通过大量虚假交易推高GMV。</p>
    <p>举报人表示，在任职期间，他亲眼见证了平台某年的双十一GMV是如何从真实数据不到200亿，通过层层"加工"后被宣传为超过500亿的全过程。</p>
    <h2>市场监管部门立案</h2>
    <p>事件曝光后，国家市场监督管理总局迅速做出反应，已正式立案调查。根据相关法规，如果数据造假行为被认定，该平台面临的罚款金额可能高达上一年度销售额的5%。</p>
    <p>此外，证监部门也在关注此事。如果造假数据影响了上市公司的信息披露，相关责任人将面临更严重的法律后果。</p>
    <h2>平台方保持沉默</h2>
    <p>截至目前，涉事电商平台尚未对举报内容做出任何公开回应。该平台的投资者关系部门仅在内部邮件中表示"正在核实相关信息"，但未给出具体时间表。</p>
    <p>本网将持续关注监管部门的调查结果。</p>
  `,
  relatedArticles: [
    { id: "article-10", title: "某知名企业高管群聊记录外泄，内部黑暗操作全曝光", excerpt: "聊天记录涉及价格垄断、商业贿赂等多重违法内容。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20with%20amber%20lighting%2C%20abstract%20phone%20screen%20glowing%2C%20tense%20and%20secretive%20atmosphere%2C%20cinematic%20style&width=800&height=600&seq=related-23&orientation=landscape", date: "2026-07-06" },
    { id: "article-11", title: "某综艺节目导演组内部音频流出，剧本安排细节曝光", excerpt: "音频清晰记录了导演组如何设计冲突情节和安排选手淘汰顺序。", imageUrl: "https://readdy.ai/api/search-image?query=Dark%20TV%20studio%20control%20room%20with%20warm%20amber%20monitors%2C%20cinematic%20atmosphere%2C%20editorial%20style&width=800&height=600&seq=related-24&orientation=landscape", date: "2026-07-05" },
  ],
};

const canonicalDetails: Record<string, ArticleDetailData> = {
  'article-1': a1,
  'article-2': a2,
  'article-3': a3,
  'article-4': a4,
  'article-5': a5,
  'article-6': a6,
  'article-7': a7,
  'article-8': a8,
  'article-9': a9,
  'article-10': a10,
  'article-11': a11,
  'article-12': a12,
};

export const articleAliasMap: Record<string, string> = {
  'cat-article-1': 'article-1',
  'cat-article-2': 'article-5',
  'cat-article-3': 'article-7',
  'cat-article-4': 'article-2',
  'cat-article-5': 'article-4',
  'cat-article-6': 'article-8',
  'cat-article-7': 'article-3',
  'cat-article-8': 'article-6',
  'cat-article-9': 'article-9',
  'cat-article-10': 'article-10',
  'cat-article-11': 'article-11',
  'cat-article-12': 'article-12',
};

export function getArticleDetail(id: string): ArticleDetailData | undefined {
  const canonicalId = articleAliasMap[id] || id;
  return canonicalDetails[canonicalId];
}

export default canonicalDetails;